import React from 'react';
import { 
  Sparkles, 
  Scan, 
  Fingerprint, 
  Palette, 
  Clock, 
  Shield, 
  Microscope,
  Heart,
  CheckCircle2
} from 'lucide-react';
import './Dto43a.css';

const Dto43a: React.FC = () => {
  return (
    <div className="dto43a">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Snow Porcelain R</h1>
          <p>Advanced Dental Aesthetics by Yueting</p>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="intro-section container">
        <div className="intro-content">
          <div className="intro-text">
            <h2>Revolutionary Dental Aesthetics</h2>
            <p>
              Based on Snow Porcelain technology, we developed the "Snow Porcelain Rouge" 
              series, designed specifically for challenging front teeth treatments. Our 
              innovative approach ensures single veneers or braces blend seamlessly with 
              your natural teeth, allowing you to smile confidently.
            </p>
          </div>
          <div className="intro-image">
            <img 
              src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&q=80&w=1500"
              alt="Dental Treatment"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section container">
        <h2 className="section-title">Advanced Technology Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <Scan className="feature-icon" />
            <h3>German Oral Scanner</h3>
            <p>Digital simulation and 3D imaging for precise treatment planning and accurate results.</p>
          </div>
          <div className="feature-card">
            <Fingerprint className="feature-icon" />
            <h3>Bionic Texture</h3>
            <p>Unique surface texturing that mimics natural dental characteristics and personal features.</p>
          </div>
          <div className="feature-card">
            <Palette className="feature-icon" />
            <h3>Stack Staining</h3>
            <p>Advanced coloring process that perfectly matches adjacent teeth with natural gradients.</p>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="container">
          <h2 className="section-title">Our Premium Process</h2>
          <div className="process-content">
            <div className="process-info">
              <div className="process-step">
                <Microscope className="step-icon" />
                <h3>High-Precision Manufacturing</h3>
                <p>Using high-power microscopes for detailed edge carving and perfect curvature.</p>
              </div>
              <div className="process-step">
                <Shield className="step-icon" />
                <h3>Quality Assurance</h3>
                <p>Rigorous quality control and meticulous SOP implementation for exceptional results.</p>
              </div>
              <div className="process-step">
                <Heart className="step-icon" />
                <h3>Personalized Care</h3>
                <p>Individual attention to each case ensuring perfect match with natural teeth.</p>
              </div>
            </div>
            <div className="process-image">
              <img 
                src="https://images.unsplash.com/photo-1609840114035-3c981b782dfe?auto=format&fit=crop&q=80&w=1500"
                alt="Dental Laboratory"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Longevity Section */}
      <section className="longevity-section container">
        <h2 className="section-title">Exceptional Durability</h2>
        <div className="longevity-content">
          <div className="longevity-info">
            <h3>Long-Lasting Results</h3>
            <p>
              Snow Porcelain R's lifespan significantly exceeds the industry average of 
              10 years, thanks to our advanced manufacturing process and premium materials.
            </p>
            <ul className="benefits-list">
              <li>
                <CheckCircle2 className="list-icon" />
                <span>Certified ceramic blocks from international manufacturers</span>
              </li>
              <li>
                <CheckCircle2 className="list-icon" />
                <span>Harder than natural enamel for superior durability</span>
              </li>
              <li>
                <CheckCircle2 className="list-icon" />
                <span>Perfect edge fit preventing detachment</span>
              </li>
              <li>
                <CheckCircle2 className="list-icon" />
                <span>No sequelae or side effects</span>
              </li>
            </ul>
          </div>
          <div className="maintenance-tips">
            <h3>Maintenance Guidelines</h3>
            <div className="tips-grid">
              <div className="tip-card">
                <Clock className="tip-icon" />
                <h4>Regular Care</h4>
                <p>Maintain good cleaning habits with daily brushing and flossing.</p>
              </div>
              <div className="tip-card">
                <Sparkles className="tip-icon" />
                <h4>Professional Cleaning</h4>
                <p>Schedule regular dental cleaning and maintenance visits.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dto43a;